/* ============================================================
   Lettoon — Homepage hero slider (Ian, 2026-09-14).

   Minimal plumbing on top of the journal-hero markup: swap which
   [data-hero-slide] is [hidden], auto-advance on a timer, loop in both
   directions, and pause the timer whenever the visitor's mouse or keyboard
   focus is anywhere inside the slider. Every other slide is real journal-
   hero markup untouched — this file owns no layout, only which one is
   visible.

   Two accessibility/perf rules baked in on purpose:
   - prefers-reduced-motion: reduce -> autoplay never starts. Manual nav
     (dots/arrows) keeps working either way; this only kills the timer.
   - hover OR focus anywhere in the slider pauses it; leaving both resumes
     it. A visitor tabbing through the primary/secondary links or a dot
     should never have the slide change out from under them mid-read.
   ============================================================ */
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-lt-hero-slider]');
  if (!roots.length) return;

  Array.prototype.forEach.call(roots, initSlider);

  function initSlider(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');
    // A single slide has nothing to rotate to — leave it exactly as
    // server-rendered (no nav to wire, no timer to start).
    if (slides.length < 2) return;

    var interval = parseInt(root.dataset.interval, 10) || 7000;
    var reducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var current = 0;
    var timer = null;

    function show(index) {
      // Wraps both directions: -1 from slide 0 loops to the last slide,
      // slides.length from the last slide loops back to slide 0.
      index = ((index % slides.length) + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.hidden = i !== index;
      });
      dots.forEach(function (dot, i) {
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
      current = index;
    }

    function next() { show(current + 1); }
    function prev() { show(current - 1); }

    function startAutoplay() {
      if (reducedMotion) return;
      stopAutoplay();
      timer = window.setInterval(next, interval);
    }
    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.dataset.index, 10) || 0);
        // A manual jump resets the clock rather than stacking behind a
        // stale interval — the next auto-advance is a full interval away
        // from what the visitor just chose, not from page load.
        startAutoplay();
      });
    });
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    // Keyboard-focus pause: focusin fires for ANY descendant gaining focus
    // (the primary link, a dot, an arrow); focusout fires on every focus
    // move, including one still inside the slider, so check whether focus
    // actually LANDED outside before resuming. Deferred a tick because
    // relatedTarget/activeElement isn't settled yet at focusout time in
    // every browser.
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!root.contains(document.activeElement)) startAutoplay();
      }, 0);
    });

    show(0);
    startAutoplay();
  }
})();
